export const USER_ROLE_LABELS = {
  ADMIN: "Administrador",
  MODERATOR: "Moderador",
  MANAGER: "Gestor de tenant",
} as const;

export const ZONE_LABELS = {
  ALTA_CBA: "Alta Córdoba",
  ALTO_ALBERDI: "Alto Alberdi",
  COSTANERA_ESTE: "Costanera Este",
  DUARTE_QUIROS: "Duarte Quirós",
  GUEMES: "Güemes",
  MERCADO_NORTE: "Mercado Norte",
  MUJER_URBANA: "Mujer Urbana",
  PASAJE: "Pasaje de los teatros",
  PLAZA_COLON: "Plaza Colón",
  PLAZA_SAN_MARTIN: "Plaza San Martín",
  PUEYRREDON: "Pueyrredón",
  UNIVERSITARIA: "Universitaria",
};

export const GENDER_LABELS = {
  ANY: "Todos los roles",
  FEMININE: "Roles femeninos",
  MASCULINE: "Roles masculinos",
  NON_BINARY: "Roles no binarios",
};

export const PAYMENT_TYPE_LABELS = {
  LOGISTICS_COSTS: "Pago de Viáticos",
  FEES: "Remunerado",
};

export const CASTING_REVIEW_STATUS_LABELS = {
  PENDING: "Pendiente",
  PUBLISHED: "Publicado",
  REJECTED: "Rechazado",
} as const;

export const EVENT_VISIBILITY_LABELS = {
  PUBLIC: "Público",
  PRIVATE: "Sólo como horario ocupado",
  INTERNAL: "Sólo para staff",
} as const;

export const EVENT_CATEGORY_LABELS = {
  THEATRICAL_SHOW: "Espectáculo teatral",
  REHEARSAL: "Ensayo",
  OTHER: "Otros",
} as const;

export const EVENT_BOOKING_STATUS_LABELS = {
  PENDING_CONTACT: "Pendiente de contacto",
  CONFIRMED: "Confirmado",
  REJECTED: "Rechazado",
} as const;

/** Select keys "1"–"12" → month name (Spanish, capitalized) */
export const MONTH_SELECT_LABELS = {
  "1": "Enero",
  "2": "Febrero",
  "3": "Marzo",
  "4": "Abril",
  "5": "Mayo",
  "6": "Junio",
  "7": "Julio",
  "8": "Agosto",
  "9": "Septiembre",
  "10": "Octubre",
  "11": "Noviembre",
  "12": "Diciembre",
} as const;